import { FaCircleCheck, FaCircleInfo } from "react-icons/fa6";
import { ToastContainer } from "react-toastify";


export const Toast = () => {
  return (
    <ToastContainer
      closeOnClick={true}
      position="top-center"
      theme="colored"
      closeButton={false}
      hideProgressBar={true}
      newestOnTop={false}
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      icon={({ type }) => {
        if (type === "success") {
          return <FaCircleCheck className="text-success_lighter size-6" />;
        } else if (type === "error") {
          return <FaCircleInfo className="text-error_main size-6" />;
        } else if (type === "warning") {
          return <FaCircleInfo className="text-warning_main size-6" />;
        }
        return null;
      }}
    />
  );
};

export const ToastSuccessMsg = ({ message }: { message: string }) => {
  return (
    <p className="text-success_darker leading-[1.375rem] text-sm font-normal">
      {message}
    </p>
  );
};

export const ToastErrorMsg = ({ message }: { message: string }) => {
  return (
    <p className="text-error_main leading-[1.375rem] text-sm font-normal">
      {message}
    </p>
  );
};

export const ToastWarningMsg = ({ message }: { message: string }) => {
  return (
    <p className="text-warning_main leading-[1.375rem] text-sm font-normal">
      {message}
    </p>
  );
};

